/**
 * Cleaning Standards Service – real API only.
 */

import { serviceLogger } from '../utils/serviceLogger';
import { normalizeServiceError } from '../utils/serviceError';
import { convertShiftsFromAPIFormat, convertShiftsToAPIFormat } from '../utils/cleaningStandardsUtils';
import * as realImpl from './real/cleaningStandardsService.real';

export const getFacilityStandards = async (facilityId) => {
  try {
    return await realImpl.getFacilityStandards(facilityId);
  } catch (error) {
    serviceLogger.error('[getFacilityStandards] Error:', error);
    throw normalizeServiceError(error);
  }
};

export const upsertFacilityStandards = async (facilityId, standards) => {
  try {
    return await realImpl.upsertFacilityStandards(facilityId, standards);
  } catch (error) {
    serviceLogger.error('[upsertFacilityStandards] Error:', error);
    throw normalizeServiceError(error);
  }
};

export { convertShiftsFromAPIFormat, convertShiftsToAPIFormat };
